// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getExternalDriverRates = ({ orderID }: any, params: any): any =>
  axios.get(`${baseUrl}/api/order/${orderID}/external-driver/rates`, { params })

export const postExternalDriver = (payload: any, params: any): any =>
  axios.post(`${baseUrl}/api/order/${payload.orderID}/external-driver/assign`, payload, { params })

export const postExternalDriverV2 = (payload: any, params: any): any =>
  axios.post(`${baseUrl}/api/v2/order/${payload.orderID}/external-driver/assign`, payload, {
    params,
  })

export const cancelExternalDriver = (payload: any): any =>
  axios.put(`${baseUrl}/api/order/${payload.orderID}/external-driver/cancel`, payload)

export const cancelExternalDriverV2 = (payload: any): any =>
  axios.put(`${baseUrl}/api/v2/order/${payload.orderID}/external-driver/cancel`, payload)

export const getDriverHistory = (payload: any): any =>
  axios.get(`${baseUrl}/api/order/${payload.orderID}/external-driver`, payload)

export const putContactCustomer = (payload: any): any =>
  axios.put(`${baseUrl}/api/customer-support/orders/${payload}/contact-customer`)

export const putContinueOrder = (order_id: any): any =>
  axios.put(`${baseUrl}/api/order/${order_id}/approve-partial-fulfill`)
